// Core
import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import PhoneInput from 'react-phone-number-input';
import { 
  Box, 
  Button, 
  Flex, 
  Text, 
  Grid, 
  Divider, 
  Image,
  FormControl,
  FormLabel,
  FormHelperText,
  Input,

  Textarea
} from '@chakra-ui/react';

// Assets
import { apiService } from 'services/ApiService';
import glow from 'assets/img/glow-9.png';

// Components
import { StarsIcon } from 'components/Icons/Icons';
import ErrorCard from 'components/Form/Errors';
import SuccessCard from 'components/Form/Success';

const PartnerForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [phone, setPhone] = useState('');
  const [website, setWebsite] = useState('');
  const [message, setMessage] = useState('');

  const [errorCard, setErrorCard] = useState();
  const [successCard, setSuccessCard] = useState();

  const [isValidInputName, setIsValidInputName] = useState(true);  
  const [isValidInputEmail, setIsValidInputEmail] = useState(true); 
  const [isValidInputMessage, setIsValidInputMessage] = useState(true); 
  const [isValidInputBusinessName, setIsValidInputBusinessName] = useState(true);   
  const [isValidInputWebsite, setIsValidInputWebsite] = useState(true);   
  const [isValidInputPhone, setIsValidInputPhone] = useState(true);    

  const [disabledButton, setDisabledButton] = useState(true);  
  const [isLoadingButton, setIsLoadingButton] = useState(false);  

  const handleNameChange = (event) => {
    setIsValidInputName(true);
    const value = event.target.value;
    setName(value);
    setIsValidInputName(value.length > 0 ? true : false);

    setErrorCard();
    setSuccessCard();
  };

  const handleEmailChange = (event) => {
    setIsValidInputEmail(true);
    const value = event.target.value;
    setEmail(value);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsValidInputEmail(emailRegex.test(value));

    setErrorCard();
    setSuccessCard();
  };

  const handleBusinessNameChange = (event) => {
    setIsValidInputBusinessName(true);
    const value = event.target.value;
    setBusinessName(value);
    setIsValidInputBusinessName(value.length > 0 ? true : false);

    setErrorCard();
    setSuccessCard();
  };

  const handleWebsiteChange = (event) => {
    setIsValidInputWebsite(true);
    const value = event.target.value;
    setWebsite(value);
    setIsValidInputWebsite(value.length > 0 ? true : false);

    setErrorCard();
    setSuccessCard();
  };

  const handlePhoneChange = (value) => {
    setIsValidInputPhone(true);
    setPhone(value);
    setIsValidInputPhone(value.length > 0 ? true : false);
    setErrorCard();
    setSuccessCard();
  };

  const handleMessageChange = (event) => {
    setIsValidInputMessage(true);
    const value = event.target.value;
    setMessage(value);
    setIsValidInputMessage(value.length > 0 ? true : false);

    setErrorCard();
    setSuccessCard();
  };

  useEffect(() => {
    if (name && email && businessName && website && phone 
      && isValidInputName && isValidInputEmail && isValidInputBusinessName && isValidInputWebsite ** isValidInputPhone
    ) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  }, [name, email, businessName, website, phone, message]);

  const handleSend = async () => {
    setIsLoadingButton(true);

    try {
      const data = { name, email, businessName, website, phone };

      const response = await apiService.sendEmailPartner(data);
      if(response.data === false || response.statusCode !== 200){
        setErrorCard(
          response.message && response.message.length > 0
            ? response.message.join(', ') 
            : 'An unknown error occurred.'
        );
        setIsLoadingButton(false);
        return;
      }

    } catch(e){
      setErrorCard(true);
      setIsLoadingButton(false);
      return;
    }

    setName('');
    setEmail('');
    setBusinessName('');
    setPhone('');
    setWebsite('');
    setMessage('');
    setDisabledButton(true);
    setIsLoadingButton(false);

    setSuccessCard('Message sent successfully');
  };

  return (
  	<Grid mt="18px" alignItems="center" templateColumns={{ sm: '1fr', md: '0.8fr 1fr' }} gap="10px" templateRows='1fr'>
      <Box maxW={{base: '100%', md: '471px'}}>
        <Flex mt="30px" gap="8px" position="relative" alignItems="center">
          <Text variant="header" 
            fontSize={{base: '32px', sm: '36px'}} w={{base: 'unset', sm: 'max-content'}}>
            PARTNER WITH US
          </Text>
          <StarsIcon fontSize="16px" />
          <Box className="abstract-grad" transform="scale(0.6)" mt="80px" />
        </Flex>

        <Text textAlign="left" p="20px 0 32px 0" maxW={{base: '100%', lg: '90%'}}>
          Interested in joining LMCT+ as a partner?
Fill out the form below and our team will be in touch within 24 hours to discuss how we can work together to promote your business to thousands of engaged Aussie members.
        </Text>

        <FormControl id="name" mb="16px">
          <Input
            value={name}
            onChange={handleNameChange}
            className={isValidInputName ? 'input-valid' : 'input-invalid'}
            type='text'
            placeholder='Full Name'
            autoComplete="off"
          />
        </FormControl>

        <FormControl id="email" mb="16px">
          <Input
            value={email}
            onChange={handleEmailChange}
            className={isValidInputEmail ? 'input-valid' : 'input-invalid'}
            type='email'
            placeholder='Email Address'
            autoComplete="off"
          />
        </FormControl>

        <FormControl id="businessName" mb="16px">
          <Input
            value={businessName}
            onChange={handleBusinessNameChange}
            className={isValidInputBusinessName? 'input-valid' : 'input-invalid'}
            type='businessName'
            placeholder='Business Name'
            autoComplete="off"
          />
        </FormControl>

        <FormControl id="website" mb="16px">
          <Input
            value={website}
            onChange={handleWebsiteChange}
            className={isValidInputWebsite ? 'input-valid' : 'input-invalid'}
            type='website'
            placeholder='Your website'
            autoComplete="off"
          />
        </FormControl>

        <PhoneInput
          international
          countryCallingCodeEditable={false}
          defaultCountry="AU"
          value={phone}
          onChange={handlePhoneChange}
          mb='24px'
          pt='15px'
          type='text'
          placeholder='Your phone'
          autoComplete="off"
          color='gray.200'
          className={isValidInputPhone ? 'input-valid' : 'input-invalid'} />

        {/*<FormControl id="phone" mb="16px">
          <Input
            value={phone}
            onChange={handlePhoneChange}
            className={isValidInputPhone ? 'input-valid' : 'input-invalid'}
            type='phone'
            placeholder='Your phone'
            autoComplete="off"
          />
        </FormControl>*/}

        {/*<FormControl id="message" mb="32px">
          <Textarea
            value={message}
            onChange={handleMessageChange}
            className={isValidInputMessage ? 'input-valid' : 'input-invalid'}
            type='message'
            placeholder='Detailed description'
            autoComplete="off"
          />
        </FormControl>*/}

        <Button isLoading={isLoadingButton} variant="button-lg" disabled={disabledButton} onClick={handleSend}>Send</Button>

        <Box mt="16px" minH="100px">
          { errorCard && ( <ErrorCard error={errorCard} maxW="100%" /> )}
          { successCard && ( <SuccessCard success={successCard} maxW="100%" /> )}
        </Box>
      </Box>

      <Box position="relative" display={{base: 'none', md: 'block'}}>
        <Image src={glow} alt="Support" />
        <Box className="abstract-grad" top="50%" left="50%" transform="translate(-50%, -50%) scale(1.5)" />
      </Box>
    </Grid>
  );
};

export default PartnerForm;